export default {
  translation: {
    'New surface': 'New cell',
    'Surface successfully updated': 'Cell successfully updated',
    'Surface successfully created': 'Cell successfully created',
    'Successfully deleted node {{name}}':
      'Element(s) successfully deleted {{name}}',
    'Successfully copied nodes {{names}}':
      'Element(s) successfully copied {{name}}',
    'Successfully cut nodes {{names}}': 'Element(s) successfully cut {{names}',
    'Successfully deleted nodes {{names}}':
      'Element(s) successfully deleted {{names}',
    'All elements in your clipboard': 'All elements in your clipboard',
    'Clear clipboard': 'Clear clipboard',
    'Insert copy': 'Insert copy',
    'Insert synced copy': 'Insert synced copy',
    Judicature: 'Judicature',
    'Successfully created RIS node': 'Element(s) successfully created',
    'You have received and email to reset your password. Please check your email inbox and spam folder.':
      'You have received and email to reset your password. Please check your email inbox and spam folder.',
    Login: 'Login',
    'Please select a surface...': 'Please select a cell...',
    Submit: 'Submit',
    Cancel: 'Cancel',
    Logout: 'Logout',
    'Are you sure that you want to logout?':
      'Are you sure that you want to logout?',
    'Are you sure that you want to delete?':
      'Are you sure that you want to delete?',
    Confirm: 'Confirm',
    'Select or drag file': 'Select or drag file here',
    'Results per page': 'Results per page',
    'name is required': 'Name is required',
    'file is required': 'File is required',
    'Name of document': 'Name of document',
    'Delete {{name}}': 'Delete {{name}}',
    Delete: 'Delete',
    'Select or drag {{types}} file': 'Select or drag {{types}} file here',
    'url is required': 'Url is required',
    'text is required': 'Text is required',
    'Type your text here...': 'Type your text here...',
    'Delete note': 'Delete note',
    'Search term is required': 'Search term is required',
    'Search type is required': 'Search type is required',
    'RIS-Search': 'RIS-Search',
    'Search for Reference number, Legal Summary, Paragraph or Article. Add relevant legal text to your personal DNN.':
      'Include the legal basis in the form of paragraphs, articles, or reference numbers.',
    'Select the type of search': 'elect the type of search',
    'Federal Law': 'Federal Law',
    'Federal Standards': 'Federal Law Gazette',
    'Type search term...': 'Type your search here...',
    Search: 'Search',
    'Reset password': 'Reset password',
    'Invalid email format': 'Invalid email format',
    'Last name is required': 'Last name is required',
    'Please enter your email address used during registration':
      'Please enter your email address used during registration',
    'E-Mail': 'E-Mail',
    'Email is required': 'Email is required',
    'No password provided': 'No password provided',
    'Passwords must match': 'Passwords must match',
    'Password is too short - should be 5 chars minimum':
      'Password is too short - should be 5 chars minimum',
    Password: 'Password',
    'Confirm Password': 'Confirm Password',
    'Remember me': 'Remember me',
    'Not registered?': 'Not registered?',
    'Forgot password?': 'Forgot password?',
    'Privacy policy': 'Privacy policy',
    'We process the personal data in accordance with the data protection regulations': {
      ' The legal basis for the processing is pivotal to fulfill a contract or to carry out pre-contractual measures (Art 6 (1) (b) GDPR), or to fulfill legal obligations to which we are subject (Art 6 (1) (c) GDPR)': {
        '\n\nIn addition, processing is completed by us or a third party due to legitimate interest': {
          ' E': {
            g: {
              ' for the protection of employees and customers, for the further development of our company, of products and services in order to win back customers in order to prevent or combat fraud, and/or to prosecute or defend against legal claims (Art': {
                ' 6 (1) (f) GDPR)': {
                  ' If you have given us your consent, the processing takes place for the stated purposes (Article 6 (1) (a) GDPR)': {
                    ' You can revoke your consent at any time without affecting the legality of the processing, carried out on the basis of the consent until the revocation': {
                      ' The revocation can be submitted by e-mail to gdpr@9y': {
                        co: {
                          '\n\nB': {
                            ' Storage of IP addresses\nWhen you visit our website, data is stored on our servers for backup purposes (such as IP address, call time and visited pages)': {
                              ' We process this data for data security reasons and to ensure the stability and reliability of our system': {
                                '\n\nC': {
                                  ' Cookies\nOur website uses so-called "cookies" which are text files that are stored on your computer': {
                                    ' Cookies allow us to analyze the overall use of the website by the use of individuals': {
                                      ' You can prevent the installation of cookies by setting your browser software accordingly': {
                                        ' However, please be aware that if you do this, you may not be able to use the full functionality of this website':
                                          '',
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    Accept: 'Accept',
    'Finish registration': 'Finish registration',
    'Your registration email has been sent. To finish up your registration verify your email address by checking your email inbox and spam folder.':
      'Your registration email has been sent. To finish up your registration verify your email address by checking your email inbox and spam folder.',
    'Terms of Service': 'Terms of Service',
    'First name is required': 'First name is required',
    'You have to accept our terms of service':
      'Sie müssen unsere Nutzungsbedingungen akzeptieren',
    Registration: 'Registration',
    Register: 'Register',
    'First name': 'First name',
    'Last name': 'Last name',
    'I agree to the': 'I agree to the',
    'privacy policy': 'privacy policy',
    'and the': 'and the',
    'terms of service': 'terms of service',
    'Already registered?': 'Already registered?',
    'Your token has expired please login to continue.':
      'Your token has expired please login to continue.',
    'Not Found': 'Not Found',
    'Name of note': 'Name of note',
    'Sorry, but no records matched your query.':
      'Sorry, but no records matched your query.',
    'Try changing your search parameters.':
      'Try changing your search parameters.',
    'Sign in code': 'Registration code',
    'Sign in code is required. If you have not received it please contact the support.':
      'Registration code is required. If you have not received it please write to us at office@cortlex.at',
    Code: 'Code',
    'Create code': 'Create registration code',
    'Back to list': 'Back to list',
    'Create sign in code': 'Create registration code',
    'Used on': 'Used on',
    'Sign in URL': 'Registrierungs-URL',
    'Successfully copied to clipboard': 'Successfully copied to clipboard',
    'Insert note': 'Insert note',
    Close: 'Close',
    'Note name': 'Note name',
    'Write down a description for the note…': 'Enter your text here...',
    'Insert text field': 'Insert text field',
    'Update text field': 'Update text field',
    Page: 'Page',
    'Back to file upload': 'Back to file upload',
    'Back to legal search': 'Back to legal search',
    'Insert document': 'Insert document',
    'Legal Search': 'Legal Search',
    'Insert the legal basis in the form of paragraphs, articles or business figures.':
      'Belegen Sie Ihre Aussage rechtlich.',
    Judiciary: 'Judiciary',
    'Federal Law Gazette': 'Federal Law Gazette',
    Paragraph: 'Paragraph',
    Type: 'Type',
    'Effective date': 'Effective date',
    'Update note': 'Save',
    'Update document': 'Update document',
    'Insert placeholder': 'Insert placeholder',
    'Update placeholder': 'Update placeholder',
    'Name of protocol node': 'Placeholder name',
    'Update cell': 'Update cell',
    'Insert cell': 'Insert cell',
    'Enter surface name': 'Enter cell name',
    'Save image': 'Save image',
    'Update image': 'Save changes',
    'Back to {{surface}}': 'Back to {{surface}}',
    '{{count}} Link(s) with': '{{count}} Link(s) with',
    'Show all links': 'Show all links',
    'Link {{index}}: ': 'Link {{index}}: ',
    'Successfully added nodes to clipboard.':
      'Successfully added nodes to clipboard.',
    'Successfully added node {{name}} to clipboard.':
      'Successfully added node {{name}} to clipboard.',
    'Are you sure that you want to delete {{name}}? {{additionalText}}':
      'Are you sure that you want to delete {{name}}? {{additionalText}}',
    'Node {{name}} contain references that will be deleted. Do you want to proceed?':
      'Node {{name}} contain references that will be deleted. Do you want to proceed?',
    'Finish linking this node': 'Finish linking this node',
    'Cancel link': 'Cancel link',
    'Finish link': 'Finish link',
    'Insert cut': 'Insert cut',
    'Link name': 'Link name',
    Yes: 'Yes',
    No: 'No',
    Open: 'Open',
    'Insert questionnaire': 'Insert question',
    'Update questionnaire': 'Update question',
    'question is required': 'question is question',
    'Name of questionnaire node': 'Name of question',
    'Type your question here': 'Type your question here',
    'answer type is required': 'Answer type is required',
    'Successfully added node to global linking process.':
      'Successfully added node to global linking process.',
    'Successfully deleted a link.': 'Successfully deleted a link.',
    'Successfully pinned node {{name}} to surface.':
      'Successfully pinned node {{name}} to surface.',
    'Successfully linked text snippet to node.':
      'Successfully linked text snippet to node.',
    'How would you answer the question?': 'How would you answer the question?',
    'Node was successfully auto saved and text snippet was added to global link zone.':
      'Dokument erfolgreich gespeichert und Verlinken gestartet.',
    'Enter snippet name': 'Enter snippet name',
    'Read only': 'Read only',
    'Register for a CortLex account': 'Register for a CortLex account',
    'Do you need a CortLex account?': 'Do you need a CortLex account?',
    'You already have a CortLex account?':
      'You already have a CortLex account?',
    'Sign up for free': 'Register',
    'Sign in': 'Sign in',
    'Log in to your CortLex Account': 'Log in to your CortLex Account',
    'Remember my login on this computer': 'Remember my login on this computer',
    show: 'show',
    hide: 'hide',
    'Your email has been successfully verified. Please login with your credentials.':
      'Your email has been successfully verified. Please login with your credentials.',

    'Something went wrong, could not complete the operation':
      'Something went wrong, could not complete the operation',
    // TODO translate

    'Document was successfully auto saved and text snippet was added to global link zone.':
      'Dokument wurde erfogreich gespeichert und der Snippet befindet sich in der Global Link Zone.',

    'Share this cell': 'Share this cell',
    'Share cell': 'Share cell',
    Sharing: 'Sharing',
    '(You)': '(You)',
    'Enter email address': 'Enter email address',
    'At Last one email address is required':
      'At Last one email address is required',
    'Emails contain invalid email format':
      'Emails contain invalid email format',
    'Successfully sent invitations': 'Successfully sent invitations',
    'Include sub cells': 'Include sub cells',
    'this will share a total of {{count}}':
      'this will share a total of {{count}}',
    Owner: 'Owner',
    Viewer: 'Viewer',
    'Can view': 'Can view',
    'Successfully deleted node and removed access for {{name}} cell':
      'Successfully deleted node and removed access for {{name}} cell',
    'By deleting cell {{name}} you will lose access.':
      'By deleting cell {{name}} you will lose access.',
    'Mark all as read': 'Mark all as read',
    '{{count}} notifications': '{{count}} notifications',
    Notifications: 'Nachrichten',
    'No notifications': 'No notifications',
    'Notifications about your activity will show up here':
      'Notifications about your activity will show up here',
    'Back to Cell': 'Back to Cell',
    'Successfully deleted invitation for {{email}}':
      'Successfully deleted invitation for {{email}}',
    'Send invitations': 'Send invitations',
    'this will share every new sub cell created':
      'this will share every new sub cell created',
    'Successfully changed role for {{user}} to {{role}}':
      'Successfully changed role for {{user}} to {{role}}',
    Admin: 'Admin',
    Editor: 'Editor',
    Filler: 'Filler',
    Linker: 'Linker',
    'Filler-Linker': 'Filler-Linker',
    'Restricted-Viewer': 'Restricted-Viewer',
    'Your role on surface has been changed to {{role}}':
      'Your role on surface has been changed to {{role}}',
    'Your access to surface {{name}} has been revoked':
      'Your access to surface {{name}} has been revoked',
    'Save document': 'Save document',
    "You don't have permission to paste nodes on this surface":
      "You don't have permission to paste nodes on this surface",
    "Successfully copied surface {{name}}. It may take a while to copy {{name}} surface content. You will receive an update when it's done.":
      "Successfully copied surface {{name}}. It may take a while to copy {{name}} surface content. You will receive an update when it's done.",
  },
};
